var QuestionnaireTitleComponent = (function () {
    function QuestionnaireTitleComponent() {
    }
    QuestionnaireTitleComponent.prototype.ngOnInit = function () {
    };
    QuestionnaireTitleComponent.prototype.ngAfterViewInit = function () {
    };
    return QuestionnaireTitleComponent;
}());
export { QuestionnaireTitleComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-title/questionnaire-title.component.ts.pre-build-optimizer.js